export default __webpack_public_path__ + "static/media/blur 2.8a6fa55c.jpg";